import React from 'react';
import { useSelector } from 'react-redux';
import { Card, CardBody, CardTitle, Row, Col, UncontrolledDropdown } from 'reactstrap';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const TotalAttendanceData = styled.span`
  display: flex;
  padding-top: 2%;
  font-weight: bold;
  color: black;
`;

/**
 * Componente que exibe um cartão de visualização de estatísticas. 
 * Esse componente é um card que possui um título, um ícone e um número condizente à estatística desejada.
 * @param {Object} props - Propriedades do componente.
 * @param {string} props.title - O título do cartão.
 * @param {string} props.tooltip - O texto que aparece no tooltip do cartão.
 * @param {React.ReactElement} props.icon - O ícone a ser exibido no cartão.
 * @param {string} props.data - Os dados a serem exibidos no cartão.
 * @returns {React.ReactElement}
 * @example
 * <StatisticsViewingCard
 *   title="Conversas"
 *   tooltip="Total de Conversas"
 *   icon={<HiChatAlt2 size={35} color="#fff" />}
 *   data="123"
 * />
 */
export function StatisticsViewingCard({ title, icon, data, tooltip }) {
  const systemConfiguration = useSelector((state) => state.systemConfiguration);

  const card_style = {
    borderRadius: systemConfiguration.border_radius
  };

  const card_body_style = {
    padding: '1rem',
    borderRadius: systemConfiguration.border_radius
  };

  return (
    <Card style={card_style} title={tooltip ?? title}>
      <CardBody style={card_body_style}>
        <Row>
          <Col>
            <CardTitle
              tag="h6"
              className="text-uppercase font-weight-bold mb-0 text-black h6"
            >
              {title}
            </CardTitle>
            <TotalAttendanceData>
              {data}
            </TotalAttendanceData>
          </Col>
          <Col className="col-auto align-content-center justify-content-center">
            {icon}
          </Col>
        </Row>
      </CardBody>
    </Card>
  );
}

StatisticsViewingCard.propTypes = {
  title: PropTypes.string.isRequired,
  icon: PropTypes.element.isRequired,
  data: PropTypes.string.isRequired
};